/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import PreferenceDetailList from './PreferenceDetailList';

export default function PreferenceDetail({
    choices = [],
    dates = [],
    nights = 0,
    preferences = {},
    handlePreferenceChange,
    disablePreferences = false,
    permitCategory,
    permitId,
}) {
    if (!choices || !dates) {
        return null;
    }

    return (
        <PreferenceDetailList
            choices={choices}
            dates={dates}
            nights={nights}
            preferences={preferences}
            handlePreferenceChange={handlePreferenceChange}
            disablePreferences={disablePreferences}
            permitCategory={permitCategory}
            permitId={permitId}
        />
    );
}

PreferenceDetail.defaultProps = {
    choices: [],
    dates: [],
    nights: 0,
    preferences: {},
    disablePreferences: false,
};

PreferenceDetail.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.shape({})),
    dates: PropTypes.arrayOf(PropTypes.any),
    nights: PropTypes.number,
    preferences: PropTypes.objectOf(PropTypes.string),
    handlePreferenceChange: PropTypes.func,
    disablePreferences: PropTypes.bool,
    permitCategory: PropTypes.number,
    permitId: PropTypes.string,
};
